// extracted by mini-css-extract-plugin
export default {"root":"Radio_root__ooWSf","checkmark":"Radio_checkmark__B5xJU","size-big":"Radio_size-big__qPDsz","size-medium":"Radio_size-medium__wElfg","size-tiny":"Radio_size-tiny__pW4kz"};